class SubNav {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.nav = document.getElementById(`ac-localnav-${this.sectionId}`);
    this.checkbox = document.getElementById(`ac-ln-menustate-${this.sectionId}`);
    this.menuTray = document.getElementById(`ac-ln-menutray-${this.sectionId}`);
    this.openButton = document.getElementById(`ac-ln-menustate-${this.sectionId}-open`);
    this.closeButton = document.getElementById(`ac-ln-menustate-${this.sectionId}-close`);

    this.curtain = this.nav.nextElementSibling;
    
    if (!this.nav || !this.checkbox || !this.curtain) {
      console.error('SubNav essential elements not found for section:', this.sectionId);
      return;
    }

    this.isScrollTriggerMode = this.nav.dataset.scrollTrigger === 'true';
    if (this.isScrollTriggerMode) {
      this.initScrollTrigger();
    } else {
      this.stickyPlaceholder = document.getElementById(`ac-ln-sticky-placeholder-${this.sectionId}`);
      this.sentinel = document.getElementById(`ac-ln-sentinel-${this.sectionId}`);
      if (this.sentinel && this.stickyPlaceholder) {
        this.setPlaceholderHeight();
        this.initStickyNav();
      }
    }
    
    this.initMenuToggle();
  }

  setPlaceholderHeight() {
    const navHeight = this.nav.getBoundingClientRect().height;
    if (navHeight > 0) {
      this.stickyPlaceholder.style.height = `${navHeight}px`;
    }
  }

  initStickyNav() {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
    const observer = new IntersectionObserver((entries) => {
      this.nav.classList.toggle('ac-ln-sticking', !entries[0].isIntersecting);
    }, {
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
      threshold: 0
    });
    observer.observe(this.sentinel);
  }

  initScrollTrigger() {
    this.triggerDistance = parseInt(this.nav.dataset.scrollPx, 10);
    this.handleScroll = () => {
      this.nav.classList.toggle('is-visible', window.scrollY > this.triggerDistance);
    };
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll(); 
  }

  initMenuToggle() {
    const ctaButton = this.nav.querySelector('.ac-ln-button');
    if (ctaButton) {
      ctaButton.addEventListener('click', () => {
        this.checkbox.checked = false;
        this.handleMenuStateChange(false);
      });
    }
    
    this.openButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.checkbox.checked = true;
      this.handleMenuStateChange(true);
    });

    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.checkbox.checked = false;
      this.handleMenuStateChange(false);
    });

    this.checkbox.addEventListener('change', () => {
      this.handleMenuStateChange(this.checkbox.checked);
    });

    this.curtain.addEventListener('click', () => {
      this.checkbox.checked = false;
      this.handleMenuStateChange(false);
    });

    this.menuTray.addEventListener('click', (event) => {
      const link = event.target.closest('.ac-ln-menu-link');
      if (!link) {
        return;
      }
      this.checkbox.checked = false;
      this.handleMenuStateChange(false);
    });
  }

  handleMenuStateChange(isOpen) {
    this.nav.classList.toggle('ac-ln-open', isOpen);
    document.documentElement.classList.toggle('ac-localnav-open', isOpen);
    
    if (isOpen) {
      this.nav.classList.add('ac-ln-opening');

      setTimeout(() => {
        this.nav.classList.remove('ac-ln-opening');
      }, 600);

      setTimeout(() => {
        const firstLink = this.menuTray.querySelector('a, button');
        if (firstLink) firstLink.focus();
      }, 50);
    } else {
      this.openButton.focus();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.shopify-section .ac-localnav').forEach(navElement => {
    const sectionId = navElement.id.replace('ac-localnav-', '');
    if (sectionId) {
      new SubNav(sectionId);
    }
  });
});